import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import WelcomeScreen from './components/WelcomeScreen';
import QuestionScreen from './components/QuestionScreen';
import ResultScreen from './components/ResultScreen';
import { discQuestions } from './data/discQuestions';
import { generateCareerRecommendations } from './data/careerRecommendations';
import { calculateDISCScores, calculatePercentages, generateInterpretation } from './utils/discCalculator';
import './App.css';

function App() {
  const [currentScreen, setCurrentScreen] = useState('welcome');
  const [currentQuestionIndex, setCurrentQuestionIndex] = useState(0);
  const [answers, setAnswers] = useState({});
  const [results, setResults] = useState(null);

  const handleStart = () => {
    setCurrentScreen('question');
    setCurrentQuestionIndex(0);
    setAnswers({});
  };

  const handleAnswer = (answer) => {
    setAnswers(prev => ({
      ...prev,
      [answer.questionId]: answer
    }));
  };

  const handleNext = () => {
    if (currentQuestionIndex < discQuestions.length - 1) {
      setCurrentQuestionIndex(prev => prev + 1);
    } else {
      calculateResults();
    }
  };

  const handleBack = () => {
    if (currentQuestionIndex > 0) {
      setCurrentQuestionIndex(prev => prev - 1);
    }
  };

  const calculateResults = () => {
    const answerArray = Object.values(answers);
    const scores = calculateDISCScores(answerArray);
    const percentages = calculatePercentages(scores);
    const careers = generateCareerRecommendations(scores);
    const interpretation = generateInterpretation(percentages);
    
    setResults({
      scores,
      percentages,
      careers,
      interpretation
    });
    setCurrentScreen('results');
  };

  const handleRestart = () => {
    setCurrentScreen('welcome');
    setCurrentQuestionIndex(0);
    setAnswers({});
    setResults(null);
  };

  const currentQuestion = discQuestions[currentQuestionIndex];
  const selectedAnswers = answers[currentQuestion?.id];

  return (
    <div className="app-container">
      <AnimatePresence mode="wait">
        {currentScreen === 'welcome' && (
          <motion.div key="welcome" initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }} transition={{ duration: 0.5 }}>
            <WelcomeScreen onStart={handleStart} />
          </motion.div>
        )}
        {currentScreen === 'question' && (
          <motion.div key="question" initial={{ opacity: 0, x: 50 }} animate={{ opacity: 1, x: 0 }} exit={{ opacity: 0, x: -50 }} transition={{ duration: 0.5 }}>
            <QuestionScreen 
              question={currentQuestion}
              currentQuestion={currentQuestionIndex + 1}
              totalQuestions={discQuestions.length}
              onAnswer={handleAnswer}
              onBack={handleBack}
              onNext={handleNext}
              selectedAnswers={selectedAnswers}
            />
          </motion.div>
        )}
        {currentScreen === 'results' && (
          <motion.div key="results" initial={{ opacity: 0, scale: 0.95 }} animate={{ opacity: 1, scale: 1 }} exit={{ opacity: 0, scale: 0.95 }} transition={{ duration: 0.5 }}>
            <ResultScreen results={results} onRestart={handleRestart} />
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
}

export default App;